<?xml version="1.0" encoding="UTF-8"?>
<svg id="Livello_2" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 22 22.2">
  <defs>
    <linearGradient id="borderGradient" x1="10.9" y1="0" x2="10.9" y2="22.2" gradientUnits="userSpaceOnUse">
      <stop offset="0" stop-color="#dd3f7f"/>
      <stop offset="0.7" stop-color="#674751"/>
      <stop offset="1" stop-color="#4b4043"/>
    </linearGradient>
    <linearGradient id="iconGradient" x1="10.9" y1="6.1" x2="10.9" y2="16.7" gradientUnits="userSpaceOnUse">
      <stop offset="0" stop-color="#dd3f7f"/>
      <stop offset="0.7" stop-color="#674751"/>
      <stop offset="1" stop-color="#4b4043"/>
    </linearGradient>
  </defs>
  <path
    d="M15.3,10.2h-3.5v-3.5c0-.5-.4-.9-.9-.9s-.9.4-.9.9v3.5h-3.5c-.5,0-.9.4-.9.9s.4.9.9.9h3.5v3.5c0,.5.4.9.9.9s.9-.4.9-.9v-3.5h3.5c.5,0,.9-.4.9-.9s-.4-.9-.9-.9Z"
    fill="url(#iconGradient)"
  />
  <path
    d="M15.5.7H6.3C3.1.7.6,3.2.6,6.3v9.5c0,3.1,2.5,5.7,5.7,5.7h9.2c3.2,0,5.7-2.6,5.7-5.7V6.3c0-3.1-2.5-5.6-5.7-5.6ZM19.6,15.8c0,2.2-1.8,4-4,4H6.2c-2.2,0-4-1.8-4-4V6.3c0-2.2,1.8-4,4-4h9.4c2.2,0,4,1.8,4,4,0,0,0,9.5,0,9.5Z"
    fill="url(#borderGradient)"
  />
</svg>
